require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./configurations-env-vars.json") })
        }
      }, "path---configurations-env-vars");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---configurations-env-vars!./.cache/json/configurations-env-vars.json
// module id = 421
// module chunks = 231608221292675